"use client";

import { c as _c } from "react/compiler-runtime";
import { Shield, FileCheck, Users } from "lucide-react";
export function TrustPanel() {
  const $ = _c(5);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h3 className="text-2xl font-semibold mb-4">Deutschlands Marktplatz für Ökopunkte</h3>;
    t1 = <p className="text-white/90 mb-8 leading-relaxed">Als seriöser Marktplatz bringen wir Anbieter und Käufer zusammen. Mit Ihrer Anmeldung stellen wir sicher, dass nur echte Interessenten miteinander in Kontakt treten.</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-start gap-4"><div className="flex-shrink-0 w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center"><Shield className="w-5 h-5" /></div><div><h4 className="font-medium mb-1">Echte Interessenten</h4><p className="text-sm text-white/80">Nur angemeldete Nutzer können Angebote einsehen und Kontakt aufnehmen.</p></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-start gap-4"><div className="flex-shrink-0 w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center"><FileCheck className="w-5 h-5" /></div><div><h4 className="font-medium mb-1">Rechtssichere Abwicklung</h4><p className="text-sm text-white/80">Behördlich genehmigte Maßnahmen mit vollständiger Dokumentation.</p></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="hidden lg:flex flex-col justify-center p-8 text-white rounded-l-2xl bg-tenant-primary"><div className="max-w-sm">{t0}{t1}<div className="space-y-5">{t2}{t3}<div className="flex items-start gap-4"><div className="flex-shrink-0 w-10 h-10 rounded-lg bg-white/20 flex items-center justify-center"><Users className="w-5 h-5" /></div><div><h4 className="font-medium mb-1">Persönliche Betreuung</h4><p className="text-sm text-white/80">Ein Ansprechpartner begleitet Sie durch den gesamten Prozess.</p></div></div></div><p className="mt-8 text-sm text-white/70">Kostenlos und unverbindlich – seit 2019</p></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}